import http from "../js/axios";
import { addAuthParams } from "../js/common";
class HomeSerive {
  login(params) {
    params.AuthKey = "";
    return http.get("/Admin/Services/Recharge.asmx/Authenticate", {
      params,
    });
  }
  forgotPassword(params) {
    return http.get("/Admin/Services/Recharge.asmx/Forgot_Password", {
      params,
    });
  }
  register(params) {
    return http.get("/Admin/Services/Recharge.asmx/Registration", {
      params,
    });
  }
  verifyOTP(params) {
    return http.get("/Admin/Services/Recharge.asmx/Verify_OTP", {
      params,
    });
  }
  verifyRegisterOTP(params) {
    return http.get("/Admin/Services/Recharge.asmx/Verify_Reg_OTP", {
      params,
    });
  }

  changePassword(params) {
    return http.get("/Admin/Services/Recharge.asmx/Change_Password", {
      params,
    });
  }
  updateProfile(params) {
    params = addAuthParams(params);
    return http.get("/Admin/Services/Recharge.asmx/Update_User_Profile", {
      params,
    });
  }
  getProfile() {
    let params = addAuthParams({});
    return http.get("/Admin/Services/Recharge.asmx/User_Profile", {
      params,
    });
  }
}
export default new HomeSerive();
